import { z } from "zod";

export const DEMO_ROLES = ["PR", "Marketing", "Communications", "Executive", "Other"] as const;
export const DEMO_SIZES = ["1-10", "11-50", "51-200", "201-1000", "1000+"] as const;

export const demoRequestSchema = z.object({
  name: z.string().trim().min(1, "Name is required").max(120),
  email: z.string().trim().email("Enter a valid work email").max(180),
  company: z.string().trim().min(1, "Company is required").max(120),
  role: z.enum(DEMO_ROLES).optional().or(z.literal("")),
  size: z.enum(DEMO_SIZES).optional(),
  country: z.string().trim().max(80).optional().or(z.literal("")),
  useCase: z.string().trim().max(2000).optional().or(z.literal("")),
  bestTime: z.string().trim().max(80).optional().or(z.literal("")),
  consent: z.literal(true, { errorMap: () => ({ message: "Consent is required" }) }),
  // honeypot - must remain empty
  website: z.string().max(0).optional(),
  // contextual hidden fields
  pagePath: z.string().trim().max(500).optional().or(z.literal("")),
  formName: z.string().trim().max(80).optional().or(z.literal("")),
  locale: z.enum(["en", "bg"]).optional(),
  landingRoute: z.string().trim().max(300).optional().or(z.literal("")),
  campaignVersion: z.string().trim().max(40).optional().or(z.literal("")),
  utm_source: z.string().trim().max(100).optional().or(z.literal("")), 
  utm_medium: z.string().trim().max(100).optional().or(z.literal("")), 
  utm_campaign: z.string().trim().max(100).optional().or(z.literal("")), 
  utm_content: z.string().trim().max(100).optional().or(z.literal("")), 
  utm_term: z.string().trim().max(100).optional().or(z.literal("")),
  // result of the browser-side HubSpot Forms API submission, for the backup record
  hubspotOk: z.boolean().optional(),
  hubspotReason: z.string().max(120).optional(),
});

export type DemoRequest = z.infer<typeof demoRequestSchema>;